<template>
  <div class="container">
    <container :active_path="path" :plate="'云项目'">
      <div class="base-warp">
        <div class="head">
          <el-form :model="form" ref="form" label-width="80px" :inline="true" size="mini">
            <el-form-item label="楼盘名称">
              <el-input v-model="form.name" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="城市">
              <el-select v-model="selectedCity" clearable :disabled="subStation" placeholder="请选择"  @change="handleCity" >
                <el-option v-for="item in regions" :key="item._id.$oid" :label="item.label" :value="item.label" > </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域">
              <el-cascader v-model="form.region" :options="selectedCityRegion" :props="{ label: 'label', value: 'label', children: 'children' }" clearable :key="cascaderIndex" > </el-cascader>
            </el-form-item>
            <el-form-item label="价格区间">
              <div class="flex-box">
                <el-input type="number" v-model="form.price.min" placeholder="最低价格"></el-input>
                <span>-</span>
                <el-input type="number" v-model="form.price.max" placeholder="最高价格"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="物业类型">
              <el-select v-model="form.types" placeholder="请选择" size="mini">
                <el-option :label="item" :value="item" v-for="(item, index) in types" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="confirm">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="add">添加楼盘</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-box">
          <el-table :data="tableData" border size="mini" :header-cell-style="{ background: '#f7f7f7', color: '#999', textAlign: 'center', fontWeight: 'normal' }">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="name" label="楼盘名称" show-overflow-tooltip></el-table-column>
            <el-table-column label="物业类型" show-overflow-tooltip align="center">
              <template slot-scope="s">
                <div v-if="s.row.housetype">
                  <span class="btn-text" v-for="(item, index) in JSON.parse(s.row.housetype)" :key="index">{{ item }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" show-overflow-tooltip align="center">
              <template slot-scope="s">
                <span class="text-success" v-if="s.row.putaway">上架</span>
                <span class="text-danger" v-else>下架</span>
              </template>
            </el-table-column>
            <el-table-column prop="city" label="城市" show-overflow-tooltip align="center" ></el-table-column>
            <el-table-column prop="region" label="区域" show-overflow-tooltip></el-table-column>
            <el-table-column prop="average_price" label="当前单价" show-overflow-tooltip>
              <template slot-scope="s">
                <span v-if="s.row.average_price">{{ s.row.average_price }}元/㎡</span>
              </template>
            </el-table-column>
            <el-table-column label="置业顾问" show-overflow-tooltip align="center">
              <template slot-scope="s">
                <span v-if="s.row.brokers">已设置</span>
              </template>
            </el-table-column>
            <el-table-column prop="index" label="户型信息" show-overflow-tooltip align="center">
              <template slot-scope="s">
                <span class="btn-text link-text" @click="addHouseType(s.row._id['$oid'])">添加</span>
                <span class="btn-text link-text" @click="getHouseType(s.row)">查看</span>
              </template>
            </el-table-column>
            <el-table-column prop="index" label="用户点评" show-overflow-tooltip align="center">
              <template slot-scope="s">
                <project-evaluate :id="s.row._id['$oid']" :key="s.row._id['$oid']"></project-evaluate>
              </template>
            </el-table-column>
            <el-table-column prop="index" label="关联文章" align="center">
              <template slot-scope="s">
                <el-row>
                  <el-col :span="12" :offset="0"><project-expert :id="s.row._id['$oid']" :key="s.row._id['$oid']" :city="s.row.city"></project-expert></el-col>
                  <el-col :span="12" :offset="0"><project-expert-list :id="s.row._id['$oid']" :key="s.row._id['$oid']"></project-expert-list></el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column prop="index" label="操作" width="210">
              <template slot-scope="s">
                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button>
                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                <el-button type="primary" size="mini" @click="edit(s.row)" plain>编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="page-tion" @current-change="currentChange" layout="prev, pager, next" :page-size="pagesize" :total="total" background> </el-pagination>
      </div>
    </container>
    <router-view></router-view>
  </div>
</template>

<script>
import Container from "../../../components/container.vue";
import ProjectEvaluate from "../../../components/project-evaluate.vue";
import ProjectExpertList from "../../../components/project-expert-list.vue";
import ProjectExpert from "../../../components/project-expert.vue";
import baseRegion from "../../../units/region";
export default {
  components: {
    Container,
    ProjectExpert,
    ProjectEvaluate,
    ProjectExpertList
  },
  data() {
    return {
      path: "/project/house",
      form: {
        name: "",
        region: "",
        price: {
          min: "",
          max: ""
        },
        types: ""
      },
      regions: [],
      tableData: [],
      pageNo: 1,
      pagesize: 14,
      total: 0,
      loading: false,
      types: ["住宅", "公寓", "商铺", "写字楼","康旅","厂房", "其他"],
      selectedCity: "",
      cascaderIndex: 0,
      subStation:false,
      managedCity:"",
    };
  },
  computed: {
    selectedCityRegion() {
      let selectedRegion = [];
      if (this.selectedCity !== "") {
        this.regions.forEach((region) => {
          if (region.label === this.selectedCity) {
            selectedRegion = region.children;
          }
        });
      }
      return selectedRegion;
    }
  },
  mounted() {
    this.getTableData();
    this.getCityList();
    let city = this.$store.getters.getuser.city;
    if(city === '全部'){
      this.subStation = false;
      city = '';
    }else{
      this.subStation = true;
    }
    this.managedCity = city;
    this.selectedCity = city;
  },
  methods: {
    getCityList() {
      this.$api.getCityList("").then((data) => {
        this.regions = data;
        this.$store.commit('setcitylist', data);
      });
    },
    getHouseType(row) {
      var project = JSON.stringify(row);
      this.$router.push({ path: "/project/house-type", query: { project } });
    },
    addHouseType(id) {
      let subStation = this.subStation;
      this.$router.push({ path: "/project/house/add-house-type", query: { id,subStation } });
    },
    edit(row) {
      var id = row._id["$oid"];
      this.$router.push({ path: "/project/house/edit", query: { id } });
    },
    del(row) {
      this.$confirm("是否确定删除" + row.name).then(
        (confirm) => {
          var params = {
            id: row._id["$oid"]
          };
          this.$api.projectDelete(params).then((data) => {
            this.$message.success(data);
            this.getTableData();
          });
        },
        (cancel) => {}
      );
    },
    putaway(row) {
      var params = {
        id: row._id["$oid"],
        putaway: !row.putaway
      };
      this.$api.projectPutaway(params).then((data) => {
        this.$message.success(data);
        this.getTableData();
      });
    },
    getTableData() {
      var region = this.form.region;
      let city = this.selectedCity;
      if (this.selectedCity == "") {
        region = "";
      }
      if (typeof region == "object" && region != "") {
        region = region[0] + "-" + region["1"];
      }else{
        region = "";
      }
      var params = {
        name: this.form.name,
        region,
        price: JSON.stringify(this.form.price),
        pageNo: this.pageNo,
        pagesize: this.pagesize,
        city,
        types:this.form.types,
      };
      this.$api.getProjectList(params).then((data) => {
        let { list, total } = data;
        this.tableData = list;
        this.total = total;
      });
    },
    confirm() {
      this.pageNo = 1;
      this.getTableData();
    },
    currentChange(page) {
      this.pageNo = page;
      this.getTableData();
    },
    add() {
      this.$router.push({ path: "/project/house/add" });
    },
    handleCity() {
      this.form.region = "";
      this.cascaderIndex++;
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (from.path == "/project/house/edit" || from.path == "/project/house/add") {
      this.getTableData();
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/main.scss";
::v-deep .el-dialog__header {
  border-bottom: 1px solid #f7f7f7;
  text-align: left;
}
</style>
